async function loadFastModeContent(href) {
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
    return false;
}
export { loadFastModeContent };
